var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.68709 0.00559939C4.31618 0.158965 0.685027 3.56909 0.265527 7.92196C0.179823 8.79254 0.229441 9.63605 0.382807 10.4435C0.382807 10.4435 0.396339 10.5382 0.441446 10.7186C0.576769 11.3231 0.779752 11.9095 1.03235 12.4598C1.91195 14.5437 3.9463 18.0305 8.51118 21.8241C8.79084 22.0586 9.20132 22.0586 9.4855 21.8241C14.0504 18.0351 16.0847 14.5483 16.9688 12.4553C17.2259 11.905 17.4244 11.3231 17.5597 10.7141C17.6003 10.5382 17.6184 10.439 17.6184 10.439C17.7221 9.89767 17.7763 9.34285 17.7763 8.77449C17.7763 3.82169 13.676 -0.17032 8.68709 0.00559939ZM8.99834 13.1409C6.64373 13.1409 4.73568 11.2329 4.73568 8.87824C4.73568 6.52363 6.64373 4.61558 8.99834 4.61558C11.3529 4.61558 13.261 6.52363 13.261 8.87824C13.261 11.2329 11.3529 13.1409 8.99834 13.1409Z",
    fill: "#139ED5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.aef5ab049ae3115121b7c9e17ac47812.svg";
export { ForwardRef as ReactComponent };